module.exports = __webpack_public_path__ + "static/media/People.9b0dfe2c.svg";